import { Dispatch } from 'react';
import { getOnboardingNotificationsData, saveOnboardingNotifications } from '../../../../services/OnboardingAPI';
import { OnboardingNotifications, IOnboardingDataPayload } from '../../../../models/OnboardingNotifications';

import { GET_ONBOARDING_NOTIFICATIONS, GetNotificationsAction } from '../types';

type IStoreOnboardingNotification = (dispatch: Dispatch<GetNotificationsAction>) => void;

export const storeOnboardingData = (
    onboardingNotifications: OnboardingNotifications
): IStoreOnboardingNotification => async (dispatch: Dispatch<GetNotificationsAction>) => {
    if (onboardingNotifications && onboardingNotifications.notificationUpdated) {
        if (!onboardingNotifications.fetchingData) {
            onboardingNotifications.fetchingData = true;

            const newOnboardingData: IOnboardingDataPayload = await getOnboardingNotificationsData();
            const mergedNotifications: IOnboardingDataPayload = onboardingNotifications.mergeUpdatedNotifications(
                newOnboardingData
            );
            onboardingNotifications.fetchingData = false;
            await saveOnboardingNotifications(mergedNotifications);
            dispatch(getNotificationsAction(mergedNotifications));
        }
    }
};

export const getNotificationsAction = (notifications: IOnboardingDataPayload): GetNotificationsAction => ({
    type: GET_ONBOARDING_NOTIFICATIONS,
    payload: {
        onboardingData: new OnboardingNotifications(notifications),
    },
});
